import { Button, Modal, useMantineTheme } from "@mantine/core";
import { QueryViewProps } from "../../../../../../types/types";
import Select from 'react-select'
import { themeProvider } from "../../../../../style/utils";
import "./queryViewModal.css";
import { useState } from "react";
import AceEditor from "react-ace";

export function QueryViewModal(props: QueryViewProps) {

    const theme = useMantineTheme();
    const [selectedQueryData, setSelectedQueryData] = useState("");

    const options = props.queryList.map(query => {
        return {value:query.query, label:query.name};   
    });
    const changeSelectedQuery=(selectedQueryObject:any) => {
        setSelectedQueryData(selectedQueryObject.value);
    }
    return (
        <>
            <Modal
                overlayColor={
                    theme.colorScheme === "dark"
                        ? theme.colors.dark[9]
                        : theme.colors.gray[2]
                }
                overlayOpacity={0.55}
                overlayBlur={3}
                opened={props.openedQueries}
                onClose={() => props.setOpenedQueries(false)}
                radius="lg"
                size="1000px">
                <div className="querySelector">
                    <Select className="querySelectorDropdown" options={options} onChange={changeSelectedQuery}/>
                </div>
                <div className="queryViewData">
                    <AceEditor
                        className="sqlEditor-editor"
                        aria-label="editor"
                        mode="mysql"
                        theme={
                            theme.colorScheme === "light" ? "github" : "solarized_dark"
                        }
                        wrapEnabled={true}
                        name="editor"
                        fontSize={16}
                        minLines={15}
                        maxLines={15}
                        width="100%"
                        height="100%"
                        showPrintMargin={false}
                        placeholder="Select a query."
                        editorProps={{$blockScrolling: true}}
                        setOptions={{
                            enableBasicAutocompletion: true,
                            enableLiveAutocompletion: true,
                            enableSnippets: true,
                        }}
                        value={selectedQueryData}
                        readOnly={true}
                    />
                </div>
                <div className="viewData-submitButton">
                    <Button sx={themeProvider} color="teal" variant="outline" onClick={()=>{props.setOpenedQueries(false)}}>Close</Button>
                </div>
            </Modal>
        </>
    );
}
